export default "__VITE_ASSET__BEqOuMFI__"